module.exports = __webpack_public_path__ + "static/media/react.11a8f47e.svg";